import PropTypes from "prop-types";
import Overlay from "react-overlays/Modal";
import Div100vh from "react-div-100vh";
import ModalClose from "components/shared/stays/ModalClose";
import styles from "components/shared/stays/ModalMap.module.scss";

export default function ModalMap({ children, show, handleClose }) {
  return (
    <Overlay
      show={show}
      onEscapeKeyDown={handleClose}
      className={styles.dialog}
      restoreFocusOptions={{ preventScroll: true }}
    >
      <Div100vh>
        <div className={styles.controls}>
          <ModalClose onClick={handleClose} overlay />
        </div>
        <div className={styles.content}>{children}</div>
      </Div100vh>
    </Overlay>
  );
}

ModalMap.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};
